import React, { useState } from 'react';
import styles from './styles/ModalCriarUsuario.module.css';

function ModalCriarUsuario({ isOpen, onClose, onSave }) {
  const [usuario, setUsuario] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');

  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  const handleKeyUp = (event) => {
    // Verifica se a tecla Caps Lock está ativa
    const isCapsLockActive = event.getModifierState('CapsLock');
    setIsCapsLockOn(isCapsLockActive);
  };

  const handleSave = async () => {
    // Validações antes de enviar ao back-end
    if (!usuario || !senha) {
      setError("Usuário e senha são obrigatórios.");
      return;
    }

    try {
      // Verifica se o usuário ou email já existem
      const response = await fetch(`http://provin.ind.br:5000/api/usuarios/criarUsuario/verificar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, email }),
      });
      const result = await response.json();

      if (result.exists) {
        setError('Usuário ou email já cadastrados.');
      } else {
        onSave({ usuario, email, senha });
        onClose();
      }
    } catch (err) {
      console.error('Erro ao verificar usuário:', err);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <h2>Novo Usuário</h2>

        {error && <p className={styles.error}>{error}</p>}

        <input type="text" placeholder="Usuário" value={usuario} onChange={(e) => setUsuario(e.target.value)} />
        <input type="email" placeholder="Email (opcional)" value={email} onChange={(e) => setEmail(e.target.value)} />

        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
          <input type="password" placeholder="Senha" onKeyUp={handleKeyUp} onBlur={() => setIsCapsLockOn(false)} value={senha} onChange={(e) => setSenha(e.target.value)} />
          {isCapsLockOn && (
            <div style={{
              position: 'absolute',
              top: '-40px', // Posiciona acima do input
              right: '10px', // Fixa no canto direito do input
              backgroundColor: '#fefefe',
              color: '#333',
              padding: '8px 12px',
              borderRadius: '5px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              fontSize: '0.9em',
              zIndex: 1000,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              whiteSpace: 'nowrap' // Evita que o texto quebre em várias linhas
            }}>
              <span role="img" aria-label="aviso">⚠️</span> Caps Lock ligado!
              <div style={{
                position: 'absolute',
                bottom: '-8px',
                right: '10px',
                width: '0',
                height: '0',
                borderLeft: '8px solid transparent',
                borderRight: '8px solid transparent',
                borderTop: '8px solid #fefefe'
              }} />
            </div>
          )}
        </div>

        <button onClick={handleSave}>Cadastrar</button>
        <button onClick={onClose}>Cancelar</button>
      </div>
    </div>
  );
}

export default ModalCriarUsuario;